module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/k36IrA/tc-custom/9781429938679.jpg?1737763719819",
      "alt": "This image is the cover for the book Killer Kids, St. Martin's True Crime Classics"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Killer Kids, St. Martin's True Crime Classics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Innocent children turned ruthless murderers...Hate-filled and deeply disturbed...They kill with cold-blooded savagery..."), _c('br'), _c('br'), _vm._v("Nothing was too good for precious Katy-- sports cars, jewelry, designer clothes. Her father, a successful South Florida businessman, could not resist any of her whims. But when he tried to curb her fast-lane lifestyle, she had him shot through the head while he slept."), _c('br'), _c('br'), _vm._v("Behind closed doors of her suburban Chicago home, Nancy Knuckles was a sadistic disciplinarian who, for years, terrorised her four children with religious fanaticism, beatings, and psychological torture, until they finally rebelled with a vengeance. After the oldest daughter strangled mom and stuffed her in a trunk, the kids partied hard, inviting their friends over for booze and rock 'n' roll."), _c('br'), _c('br'), _vm._v("Susan Cabot was a beautiful B-movie queen and obsessive mother. Her son Tim-- born a dwarf-- was pumped full of experimental drugs extracted from cadavers to increase his height. When the ex-film star's badly beaten body was discovered in her Hollywood home, little Timmy claimed she had been killed by men using Ninja methods-- before confessing."), _c('br'), _c('br'), _c('i', [_vm._v("Killer Kids ")]), _vm._v("is Clifford L. Linedecker's shocking true crime book of children who turn to murder.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clifford L. Linedecker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0